import {
  IonButton,
  IonContent,
  IonFab,
  IonFabButton,
  IonIcon,
  IonImg,
  IonPage
} from "@ionic/react";
import { close } from "ionicons/icons";
import { useState } from "react";
import CardSlides from "../components/CardSlides";

import quidbot2 from "../assets/graphics/QuidPro-Robot-2.png";

const Intro: React.FC = () => {
  const [viewIntro, setViewIntro] = useState(false);
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const handleSwipeChange = (activeSlideIndex: number) =>
    setActiveSlideIndex(activeSlideIndex);

  return (
    <IonPage>
      <IonContent fullscreen scrollY={false}>
        {!viewIntro && (
          <div className="mx-8 mt-14 h-1/3">
            <IonImg src={quidbot2} className="h-full w-full" />
          </div>
        )}
        <div
          className={`font-bold flex items-end justify-center transition-all duration-500 motion-reduce:transition-none ${
            !viewIntro ? "text-4xl my-8" : "text-2xl mt-9 mb-6"
          }`}
        >
          QuidPro
        </div>
        {viewIntro && (
          <IonFab
            className="mt-6 mr-4"
            vertical="top"
            horizontal="end"
            slot="fixed"
          >
            <IonFabButton
              color="PurpleBGBlackCross"
              onClick={() => setViewIntro(false)}
            >
              <IonIcon icon={close} />
            </IonFabButton>
          </IonFab>
        )}
        {/* @ts-ignore */}
        {viewIntro && <CardSlides onSwipe={handleSwipeChange} />}
        {!viewIntro && (
          <>
            <div className="text-normal mx-auto w-[28ch] text-white/80 ion-text-center">
              A gamified trading platform that allows you to learn, compete, and
              trade with digital currencies.
            </div>
            <div className=" justify-center mt-8 flex items-end">
              <IonButton
                fill="clear"
                color="dark"
                className="ion-button ion-button-font ion-button-text-transform-none"
                onClick={() => setViewIntro(true)}
              >
                {"What is QuidPro?"}
              </IonButton>
            </div>
          </>
        )}
        <IonButton
          expand="block"
          color="primary"
          className="mt-8 h-12 normal-case max-w-lg mx-auto px-4"
          routerLink="/auth"
          disabled={viewIntro && activeSlideIndex !== 2}
        >
          Login or Sign Up
        </IonButton>
      </IonContent>
    </IonPage>
  );
};

export default Intro;
